import request from '@/utils/request'


// 查询学校批次变更日志列表
export function listSchoolBatchChangeLog(query) {
  return request({
    url: '/biz/admin/school/batch/change/log/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询学校批次变更日志分页
export function pageSchoolBatchChangeLog(query) {
  return request({
    url: '/biz/admin/school/batch/change/log/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询学校批次变更日志详细
export function getSchoolBatchChangeLog(data) {
  return request({
    url: '/biz/admin/school/batch/change/log/detail',
    method: 'get',
    params: data
  })
}

// 新增学校批次变更日志
export function addSchoolBatchChangeLog(data) {
  return request({
    url: '/biz/admin/school/batch/change/log/add',
    method: 'post',
    data: data
  })
}

// 修改学校批次变更日志
export function updateSchoolBatchChangeLog(data) {
  return request({
    url: '/biz/admin/school/batch/change/log/edit',
    method: 'post',
    data: data
  })
}

// 修改学校批次变更日志
export function deleteSchoolBatchChangeLog(data) {
  return request({
    url: '/biz/admin/school/batch/change/log/delete',
    method: 'post',
    data: data
  })
}


// 删除学校批次变更日志
export function settleSchoolBatchChangeLog(data) {
  return request({
    url: '/biz/admin/school/batch/change/log/settle',
    method: 'post',
    data: data
  })
}

// 验收资料上传
export function uploadSchoolBatchChangeLogSettle(data) {
  return request({
    url: '/biz/admin/school/batch/change/log/settle/upload',
    method: 'post',
    data: data
  })
}
